import script from "./delete-meeting-modal.vue?vue&type=script&setup=true&lang=ts"
export * from "./delete-meeting-modal.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__